import React from 'react';
import { connect } from 'react-redux';
import { MessageBar, MessageBarType } from '@fluentui/react';
import { renderQuota } from '../../../helpers/HelperMethods';
import { limitVersioning } from '../../../GlobalConst/globalConst';
import InfoTooltip from '../../formFields/InfoTooltip';

class InfoTable extends React.Component {

    render() {

        const toolTipContent =
        <span>
                If a site storage exceeds 10 GB, the cost will be calculated as follows: <br />
                <br />
                - Out of the total consumed storage, 45% will be charged<br />&emsp;at $0.15 USD/GB per month.<br />
                - For example, if your storage is at 60 GB:<br />&emsp;45% of 60 GB * $0.15 USD = $4.05 USD monthly rate.<br />
                <br />
                The costs will be charged to the SharePoint or Teams administrator's cost center on a quarterly basis.<br />
        </span>;

        return (
            this.props.onlineLocation !== null &&
                <div style={tableStyle}>
                        <MessageBar messageBarType={MessageBarType.info}>
                            <div><span>You are about to request the creation of </span>{ this.props.onlineLocation ? <span>a SharePoint/Teams site.</span> : <span>an {this.props.locationObject.name} on-premises site.</span> }</div>
                            <table>
                                <tbody>
                                    { this.props.onlineLocation ? <tr><td style={labelColumn}><span>Free of charge quota:</span></td><td><span>up to 10 GB</span></td></tr> : <tr><td style={labelColumn}><span>Starting quota:</span></td><td><span>{renderQuota(this.props.quota)}</span></td></tr>}
                                    { this.props.onlineLocation ? <tr><td style={labelColumn}><span>Charged quota:</span></td><td><span>{this.props.locationObject.cost}<InfoTooltip content={toolTipContent} /></span></td></tr> : <tr><td style={labelColumn}><span>Yearly cost:</span></td><td><span>{this.props.locationObject.cost} (regardless of used storage)</span></td></tr> }
                                    { !this.props.isSummaryInfo && <tr><td style={labelColumn}>Default versioning settings: </td><td>File versioning is enabled for all libraries with a count limit of {limitVersioning.versionsLimit} and a time limit of {limitVersioning.versionsDays} days.</td></tr> }
                                </tbody>
                            </table>
                            { this.props.onlineLocation && !this.props.isSummaryInfo ? <span>Please note that requesting to create a SharePoint/Teams  will require your line manager’s approval.  </span> : <div></div> }
 
                            <a href="https://go.insideplus.abb.com/information-systems/gf-is/scenarios/store-and-share-digital-information/information-classification-and-labelling" target="_blank" rel="noopener noreferrer" style={{paddingLeft: 0}}>
                            Learn more about tools & Information Management guidelines.</a>

                            <div>{this.props.locationObject.remarks}</div>
                        </MessageBar>
                </div>
                
        );
    }

}

const tableStyle = {
    margin: '10px 0'
}

const labelColumn = {
    width: '165px',
    verticalAlign: 'top',
    paddingLeft: '15px'
}

const mapStateToProps = state => ({
    onlineLocation: state.newSite.OnlineLocation,
    quota: state.newSite.QuotaSize,
    locationObject : state.newSite.Location
});


export default connect(mapStateToProps, null)(InfoTable);


// WEBPACK FOOTER //
// ./src/components/CreateSite/Step1/InfoTable.js